import { MARKETPLACE_CATEGORIES, type MarketplaceProduct, type MarketplaceSort } from '@isbd/shared';

type Props = {
  selected: string | null;
  onSelect: (category: string | null) => void;
  searchQuery: string;
  onSearch: (value: string) => void;
  sortBy: MarketplaceSort;
  onSortChange: (value: MarketplaceSort) => void;
  products: MarketplaceProduct[];
};

export function CategorySidebar({
  selected,
  onSelect,
  searchQuery,
  onSearch,
  sortBy,
  onSortChange,
  products,
}: Props) {
  const counts: Record<string, number> = {};
  for (const p of products) {
    if (p.category) counts[p.category] = (counts[p.category] || 0) + 1;
  }

  return (
    <div className="mp-sidebar-sticky">
      <div className="mp-search">
        <span className="mp-search-icon" aria-hidden>
          ⌕
        </span>
        <input
          type="search"
          placeholder="Rechercher un produit..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          aria-label="Rechercher un produit"
        />
        {searchQuery ? (
          <button type="button" className="mp-search-clear" onClick={() => onSearch('')} aria-label="Effacer">
            ×
          </button>
        ) : null}
      </div>

      <div>
        <div className="mp-side-label">Affichage</div>
        <select
          className="mp-select"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value as MarketplaceSort)}
          aria-label="Trier les produits"
        >
          <option value="recent">Nouveautés</option>
          <option value="price-asc">Prix croissant</option>
          <option value="price-desc">Prix décroissant</option>
          <option value="rating">Les mieux notés</option>
        </select>
      </div>

      <div>
        <div className="mp-side-label">Catégories</div>
        <div className="mp-cat-list">
          <button
            type="button"
            className={`mp-cat-btn${!selected ? ' is-active' : ''}`}
            onClick={() => onSelect(null)}
          >
            <span className="mp-cat-label">Toutes les catégories</span>
            <span className="mp-cat-count">{products.length}</span>
          </button>
          {MARKETPLACE_CATEGORIES.map((cat) => {
            const count = counts[cat] || 0;
            const isActive = selected === cat;
            return (
              <button
                key={cat}
                type="button"
                className={`mp-cat-btn${isActive ? ' is-active' : ''}`}
                onClick={() => onSelect(isActive ? null : cat)}
              >
                <span className="mp-cat-label">{cat}</span>
                {count > 0 ? <span className="mp-cat-count">{count}</span> : null}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
